import type { IntlShape } from 'react-intl'
import type {
	ReportFormData,
	ReportListItem,
} from 'ui/ManagerFinance/ReportingBase/types'

export const reportForms: Record<string, ReportFormData> = {
	vatCalculation: {
		type: 'vat-report',
		preferredFormat: 'pdf',
		supportedFormats: ['pdf'],
		formInputs: [
			{
				key: 'date_start',
				title: (intl: IntlShape) =>
					intl.formatMessage({
						defaultMessage: 'Alkupvm',
						description: 'Label for start date',
					}),
				type: 'date',
				required: true,
				defaultValue: () => {
					// TODO: Some reasonable default, 2024 for now for demo
					return '2024-01-01'
				},
			},
			{
				key: 'date_end',
				title: (intl) =>
					intl.formatMessage({
						defaultMessage: 'Loppupvm',
						description: 'Label for end date',
					}),
				type: 'date',
				required: true,
				defaultValue: () => {
					// TODO: Some reasonable default, 2024 for now for demo
					return '2024-12-31'
				},
			},
		],
	},
	accountList: {
		type: 'chart-of-accounts-report',
		preferredFormat: 'pdf',
		supportedFormats: ['pdf', 'xls'],
		formInputs: [],
	},
	balance: {
		type: 'balance-sheet-report',
		preferredFormat: 'pdf',
		supportedFormats: ['pdf', 'xls'],
		formInputs: [
			{
				key: 'report_date',
				title: (intl) =>
					intl.formatMessage({
						defaultMessage: 'Päivämäärä',
						description: 'Label for report date',
					}),
				type: 'date',
				required: true,
				defaultValue: () => {
					// TODO: Some reasonable default, 2024 for now for demo
					return '2024-12-31'
				},
			},
		],
	},
	incomeStatement: {
		type: 'income-statement-report',
		preferredFormat: 'pdf',
		supportedFormats: ['pdf', 'xls'],
		formInputs: [
			{
				key: 'period_start',
				title: (intl: IntlShape) =>
					intl.formatMessage({
						defaultMessage: 'Alkupvm',
						description: 'Label for start date',
					}),
				type: 'date',
				required: true,
				defaultValue: () => {
					// TODO: Some reasonable default, 2024 for now for demo
					return '2024-01-01'
				},
			},
			{
				key: 'period_end',
				title: (intl) =>
					intl.formatMessage({
						defaultMessage: 'Loppupvm',
						description: 'Label for end date',
					}),
				type: 'date',
				required: true,
				defaultValue: () => {
					// TODO: Some reasonable default, 2024 for now for demo
					return '2024-12-31'
				},
			},
		],
	},
	generalLedger: {
		type: 'accounting-ledger',
		preferredFormat: 'xls',
		supportedFormats: ['pdf', 'xls'],
		formInputs: [],
	},
}

export const reportItems: ReportListItem[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päiväkirja',
				description: 'Diary',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Päiväkirjassa tositteet on listattu tositetyypin ja numeron mukaan. Tosite tiedoista näkyy tilimerkinnät sekä päivämäärä.',
				description: 'Diary descrioption',
			}),
		key: 'diary',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Pääkirja',
				description: 'General ledger',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Pääkirjassa tapahtumat näkyvät tileittäin.',
				description: 'General ledger descrioption',
			}),
		key: 'generalLedger',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tililuettelo',
				description: 'Account list',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tililuettelossa näkyy kaikki tilit, sekä niile merkittyjen tapahtumien summa.',
				description: 'Account list descrioption',
			}),
		key: 'accountList',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV-laskelma',
				description: 'Vat calculation',
			}),
		key: 'vatCalculation',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV-laskelma tileittäin',
				description: 'Vat calculation by accounts',
			}),
		key: 'vatCalculationByAccounts',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kustannuspaikkaerittely',
				description: 'Cost center breakdown',
			}),
		key: 'costCenterBreakdown',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tase',
				description: 'Balance',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tase-raportilla näkyy kaikki tasetileille merkityt tapahtumat tileittäin ryhmiteltynä.',
				description: 'Balance descrioption',
			}),
		key: 'balance',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tase (arvio)',
				description: 'balance estimate',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tase-raportilla näkyy kaikki tasetileille merkityt tapahtumat tileittäin ryhmiteltynä.',
				description: 'Balance estimate descrioption',
			}),
		key: 'balanceEstimate',
		icon: 'description',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuloslaskelma',
				description: 'Income statement',
			}),
		description: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Tuloslaskelma-raportilla näkyy kaikki tulostileille merkityt tapahtumat tileittäin ryhmiteltynä.',
				description: 'Income statement descrioption',
			}),
		key: 'incomeStatement',
		icon: 'description',
	},
]
